import { ReactElement } from 'react'
import {
    Applications,
    FMTABS,
    TAB_PAGE_VIEW,
    URLSearchParamsKeys,
} from '../../../../constants/constants'
import Entity from '../../../Entity/EntityList'
import { useSearchParams } from 'react-router-dom'
import { Box } from '@mui/material'
import ViewEntity from '../../../ViewEntity'

interface IAssetEntityList {
    assetEntityTemplateId: string
}

const AssetEntityList = (props: IAssetEntityList): ReactElement => {
    const { assetEntityTemplateId } = props
    const [searchParams] = useSearchParams()
    const tabPageView =
        searchParams.get(URLSearchParamsKeys.pageView) ||
        TAB_PAGE_VIEW.LIST_VIEW
    const isAssetListView = TAB_PAGE_VIEW.LIST_VIEW === tabPageView
    return isAssetListView ? (
        <Box sx={{ height: '100%' }}>
            <Entity
                tabIndex={FMTABS.ASSET_VIEW}
                applicationId={Applications.facilityMonitoring.id}
                templateId={assetEntityTemplateId}
            />
        </Box>
    ) : (
        <ViewEntity />
    )
}

export default AssetEntityList
